/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetPublicReservationInvoiceIsdocPathParameters } from 'api/actions/get-public-reservation-invoice-isdoc/get-public-reservation-invoice-isdoc-path-parameters';
import { GetPublicReservationInvoiceIsdocResponse } from 'api/actions/get-public-reservation-invoice-isdoc/get-public-reservation-invoice-isdoc-response';

type GetPublicReservationInvoiceIsdocQueryParameters = Record<string, any>;

/**
 * The path of the GetPublicReservationInvoiceIsdoc action.
 */
export const getPublicReservationInvoiceIsdocActionPath = new SweetPath<
  keyof GetPublicReservationInvoiceIsdocPathParameters
>('/reservations/public/invoices/{accessToken}/isdoc', { path: '{param}' });

/**
 * Creates a contextualized GetPublicReservationInvoiceIsdoc actions.
 */
export default function createGetPublicReservationInvoiceIsdocAction(axios: AxiosInstance) {
  return function getPublicReservationInvoiceIsdocAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetPublicReservationInvoiceIsdocPathParameters;
    query?: GetPublicReservationInvoiceIsdocQueryParameters;
  }) {
    const path = getPublicReservationInvoiceIsdocActionPath.insert(parameters);

    return axios.get<GetPublicReservationInvoiceIsdocResponse, GetPublicReservationInvoiceIsdocResponse>(path, {
      params: query,
      headers,
    });
  };
}
